<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange == 'en' ? 'Project' : '项目查看'"
        name="project"
      >
        <div class="total-des">
          <div class="top flex-between">
            <p class="flex-between">
              <span>{{ $lange == "en" ? "Unit" : "单元" }}:</span>
              <el-select
                filterable
                v-model="searchParams.value"
                size="mini"
                clearable
                @change="searchChange"
                :placeholder="
                  $lange == 'en' ? 'Please select unit' : '请选择单元'
                "
              >
                <el-option
                  v-for="item in selectData"
                  size="mini"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </p>
            <p class="flex-between">
              <span style="width: 70px"
                >{{ language("workShop.阶段类型") }}:</span
              >
              <el-select
                v-model="searchParams.type"
                size="mini"
                clearable
                @change="processTypeChange"
                :placeholder="language('workShop.请选择阶段类型')"
              >
                <el-option
                  v-for="item in processType"
                  size="mini"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </p>
          </div>
          <div class="bottom">
            <div class="title flex-between">
              <p>
                {{ $lange == "en" ? "Project name" : "项目名称" }}:
                {{ workshopProject.name }}
              </p>
              <div class="right">
                <div>
                  <p class="total">
                    <span
                      >{{ language("workShop.标准工时") }}:
                      {{ total.estimatedWorkingHours }}</span
                    >
                    <span
                      >{{
                        $lange == "en" ? "Actual working hours" : "实际工时"
                      }}: {{ total.actualWorkingHours }}</span
                    >
                  </p>
                  <!-- <p class="total">
                    <span
                      >{{ $lange == "en" ? "Estimated yield" : "预估产量" }}:
                      {{ total.expectedProduction }}</span
                    >
                    <span
                      >{{ $lange == "en" ? "Actual output" : "实际产量" }}:
                      {{ total.actualProduction }}</span
                    >
                  </p> -->
                </div>
                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="closeProcess"
                >{{$lange == 'en' ? 'Closing process' : "关闭工序"}}</el-button>-->
              </div>
            </div>
            <div class="body">
              <div class="lists">
                <template v-for="item in listsData">
                  <div class="list list-1 flex-between">
                    <div class="name">{{ item.name }}</div>
                    <div class="right-content">
                      <span>{{ language("workShop.阶段类型") }}</span>
                      <span>{{ item.schedule }}</span>
                      <span
                        >{{ language("workShop.标准工时") }}
                        {{ item.estimatedWorkingHours }}</span
                      >
                      <span
                        >{{ language("workShop.上限工时")
                        }}{{ item.limitWorkingHours }}</span
                      >
                      <span
                        >{{
                          $lange == "en" ? "Actual working hours" : "实际工时"
                        }}
                        {{ item.actualWorkingHours }}</span
                      >
                      <!-- <span
                        >{{ $lange == "en" ? "Estimated yield" : "预估产量" }}
                        {{ item.expectedProduction }}</span
                      >
                      <span
                        >{{ $lange == "en" ? "Actual output" : "实际产量" }}
                        {{ item.actualProduction }}</span
                      > -->
                      <span>{{
                        $lange == "en" ? "Actual output" : "操作"
                      }}</span>
                    </div>
                  </div>
                  <template v-for="itemChild in item.workshopOrderList">
                    <div class="list list-2 flex-between">
                      <div class="name">{{ itemChild.numbering }}</div>
                      <div class="right-content">
                        <span>----</span>
                        <span>{{ itemChild.schedule }}</span>
                        <span
                          >{{ language("workShop.标准工时") }}
                          {{ itemChild.estimatedWorkingHours }}</span
                        >
                        <span
                          >{{ language("workShop.上限工时") }}
                          {{ itemChild.limitWorkingHours }}</span
                        >
                        <span
                          >{{
                            $lange == "en" ? "Actual working hours" : "实际工时"
                          }}
                          {{ itemChild.actualWorkingHours }}</span
                        >

                        <!-- <span
                          >{{
                            $lange == "en" ? "Estimated yield" : "预估产量"
                          }}
                          {{ itemChild.expectedProduction }}</span
                        >
                        <span
                          >{{ $lange == "en" ? "Actual output" : "实际产量" }}
                          {{ itemChild.actualProduction }}</span
                        > -->

                        <span></span>
                      </div>
                    </div>
                    <template v-for="itemLast in itemChild.workshopProcessList">
                      <div :class="('list list-3 flex-between ')+ itemLast.type">
                        <div class="name">{{ itemLast.content }}</div>
                        <div class="right-content">
                          <span>
                            <!-- <el-tag
                              :type="
                                itemLast.type == 'FC101' ? 'success' : 'info'
                              "
                              size="mini"
                              >{{ itemLast.type== 'FC104'?'电气工序':'机械工序' }}</el-tag
                            > -->
                            <el-tag
                              type="success"
                              v-if="itemLast.type == 'FC101'"
                              size="mini"
                              >机械类</el-tag
                            >
                            <el-tag
                              type="info"
                              v-if="itemLast.type == 'FC104'"
                              size="mini"
                              >电气类</el-tag
                            >
                            <el-tag
                              type="warning"
                              v-if="itemLast.type == 'FC108'"
                              size="mini"
                              >调试类</el-tag
                            >
                          </span>
                          <span>{{ itemLast.schedule }}</span>
                          <span
                            >{{ language("workShop.标准工时") }}
                            {{ itemLast.estimatedWorkingHours }}</span
                          >
                          <span
                            >{{ language("workShop.上限工时")
                            }}{{ itemLast.limitWorkingHours }}</span
                          >
                          <span
                            >{{
                              $lange == "en"
                                ? "Actual working hours"
                                : "实际工时"
                            }}
                            {{ itemLast.actualWorkingHours }}</span
                          >
                          <!-- <span
                            >{{
                              $lange == "en" ? "Estimated yield" : "预估产量"
                            }}
                            {{ itemLast.expectedProduction }}</span
                          >
                          <span
                            >{{
                              $lange == "en" ? "Actual output" : "实际产量"
                            }}
                            {{ itemLast.actualProduction }}</span
                          > -->
                          <span class="closeProcess">
                            <el-link
                              @click="closeProcess(itemLast.id, itemLast)"
                              :underline="false"
                              v-if="itemLast.isClose == 1"
                              >{{ language("workShop.关闭阶段") }}</el-link
                            >
                          </span>
                        </div>
                      </div>
                      <div
                        v-for="(
                          itemLastMini, t
                        ) in itemLast.workshopChildProcessList"
                      >
                        <div  :class="('list list-4 flex-between ')+ itemLast.type">
                          <div class="name">{{ itemLastMini.name }}</div>
                          <div class="right-content">
                            <span>----</span>
                            <span>----</span>
                            <span
                              >{{ language("workShop.标准工时") }}
                              {{ itemLastMini.standardWorkingHours }}</span
                            >
                            <span
                              >{{ language("workShop.上限工时")
                              }}{{ itemLastMini.limitWorkingHours }}</span
                            >
                            <span
                              >{{
                                $lange == "en"
                                  ? "Actual working hours"
                                  : "实际工时"
                              }}
                              {{ itemLastMini.actualWorkingHours }}</span
                            >
                            <span class="closeProcess">
                              <el-link
                                @click="
                                  openProcess(itemLastMini.id, itemLastMini)
                                "
                                :underline="false"
                                v-if="itemLastMini.status == 1 && showOpenBotton && itemLast.processStatus==0"
                                >{{
                                  $lange == "en"
                                    ? "Closing process"
                                    : " 重启工序"
                                }}</el-link
                              >
                              <el-link
                                @click="
                                  closeProcessV2(itemLastMini.id, itemLastMini)
                                "
                                :underline="false"
                                v-if="itemLastMini.isClose == 1  "
                                >{{
                                  $lange == "en"
                                    ? "Closing process"
                                    : "关闭工序"
                                }}</el-link
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="back-btn" @click="backBtn">
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-circle-close"
      ></el-button>
    </div>
  </div>
</template>

<script>
import currency from "currency.js";

export default {
  name: "TotalDescription",
  data() {
    return {
      activeName: "project",
      searchParams: {
        value: "",
        type: "",
      },
      listsData: [],
      selectData: [],
      workshopProject: {},
      total: {
        estimatedWorkingHours: 0,
        actualWorkingHours: 0,
        expectedProduction: 0,
        actualProduction: 0,
      },
      totalDesId: "",
      searchChangeWorkshopUnitId: "",
      processType: [
        {
          name: "电气类",
          id: "FC104",
        },
        {
          name: "机械类",
          id: "FC101",
        },
        {
          name: "调试类",
          id: "FC108",
        },
      ],
      showCloseBotton: false,
      showOpenBotton:false,
    };
  },
  methods: {
    backBtn() {
      this.$router.go(-1);
    },
    searchChange(res) {
      this.searchChangeWorkshopUnitId = res;
      this.getData(res, true);
    },
    processTypeChange(e) {
      this.searchParams.type = e;
      this.getData(this.searchChangeWorkshopUnitId, true);
    },
    initData(data, isSearch) {
      let newData = data;
      this.total = {
        estimatedWorkingHours: 0,
        actualWorkingHours: 0,
        expectedProduction: 0,
        actualProduction: 0,
      };
      let selectData = [];
      for (let j in newData) {
        let item = newData[j];
        for (let i in this.total) {
          // this.total[i] += item[i];
           this.total[i]=currency(this.total[i],{ precision: 1 }).add(item[i]);
        }
        if (!isSearch) {
          selectData.push({
            id: item.id,
            name: item.name,
          });
          this.selectData = selectData;
        }
      }
    },
    getData(id = false, isSearch = false) {
      let data = {
        workshopProjectId: this.totalDesId,
      };
      if (id) {
        data.workshopUnitId = id;
      }
      if (this.searchParams.type) {
        data.workshopProcessType = this.searchParams.type;
      }
      this.ccRequest
        .do("admin/fsb/workshop/project/projectStatisticsDetails", data, "GET")
        .then((res) => {
          this.workshopProject = res.workshopProject;
          this.listsData = res.workshopUnitList;
          this.initData(res.workshopUnitList, isSearch);
        });
    },
    closeProcess(id, item) {
      // this.$prompt("你当前操作是关闭工序, 请输入产量后确定", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputPattern: /^[1-9]\d*$/,
      //   inputErrorMessage: "请输入正确的产量",
      //   type: "warning",
      //   customClass: "totalDescription",
      // }).then((val) => {
      //   if (val.value > item.expectedProduction) {
      //     return this.$message({
      //       type: "warning",
      //       message: "实际产量大于预计产量",
      //     });
      //   } else if (val.value < item.expectedProduction) {
      //     return this.$message({
      //       type: "warning",
      //       message: "实际产量小于预计产量",
      //     });
      //   }
      //   let data = {
      //     id: id,
      //     actualProduction: val.value,
      //     status: 1,
      //   };
      //   console.log(data);
      //   // return false;
      //   this.ccRequest
      //     .do("admin/fsb/workshop/project/details/save", data, "POSTJSON")
      //     .then((res) => {
      //       this.$message({
      //         type: "success",
      //         message: "工序已关闭",
      //       });
      //       this.getData(this.searchChangeWorkshopUnitId, true);
      //     });
      // });

      this.$confirm("此操作将关闭阶段, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            workshopProcessId: item.id,
            id: item.id,
            status: 2,
          };
          this.ccRequest
            .do("admin/fsb/workshop/project/details/save", data, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: "阶段已关闭",
              });
              this.getData(this.searchChangeWorkshopUnitId, true);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {});
    },
    closeProcessV2(id, item) {
      this.$confirm("此操作将关闭工序, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id: id,
            status: 1,
          };
          this.ccRequest
            .do("admin/fsb/workshop/child/process/save", data, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: "工序已关闭",
              });
              this.getData(this.searchChangeWorkshopUnitId, true);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {});
    },
    openProcess(id, item) {
      this.$confirm("此操作将重启工序, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            childProcessId: id,
          };
          this.ccRequest
            .do("admin/fsb/workshop/child/process/restart", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "工序已重启",
              });
              this.getData(this.searchChangeWorkshopUnitId, true);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.getValidate()
      .then((res) => {
        if (
          res.roleTips == "administrator" ||
          res.roleTips == "management"
        ) {
          this.showOpenBotton = true;
        }
      })
      .catch((err) => {});
    if (this.$route.query.id) {
      this.totalDesId = this.$route.query.id;
      this.getData();
      return false;
    }
    this.$router.push({
      name: "DailyTotal",
    });
  },
};
</script>

<style scoped lang="scss">
.total-des {
  max-width: 1024px;
  padding: 20px;
  min-height: 60vh;
  .top {
    justify-content: flex-start;

    p {
      // justify-content: flex-start;
      // width: 200px;
      margin-right: 20px;

      > span {
        width: 40px;
      }
    }
  }

  .bottom {
    margin-top: 20px;

    .title {
      font-weight: bolder;
      font-size: 16px;

      .right {
        display: flex;
        font-size: 12px;
        div {
          display: flex;
          align-items: center;
        }
        .total {
          height: 18px;
        }
        p {
          margin-right: 20px;
          padding: 2px 4px;
          background: #ffffdd;
          border: 1px solid #facd91;
          font-weight: normal;

          span:last-child {
            margin-left: 15px;
          }
        }
      }
    }

    .body {
      margin-top: 10px;

      .list {
        padding: 8px;
        &:hover {
          background: #f2f2f2;
        }
        > .right-content {
          display: flex;
          > * {
            text-align: center;
            width: 110px;
          }
        }
        &.list-1 {
          margin-top: 30px;
          &:first-child {
            margin-top: 20px;
          }
          font-weight: bolder;
          background: #f2f2f2;
          border: 1px solid #d7d7d7;
          padding-left: 40px;
        }
        &.list-2 {
          font-size: 12px;
          padding-left: 80px;
          border-bottom: 1px solid #d7d7d7;
        }
        &.list-3 {
          font-size: 12px;
          padding-left: 120px;
          // color: #c8c8c8;
          // color: #999494;
          border-bottom: 1px dotted #d7d7d7;
        }
        &.list-4 {
          font-size: 12px;
          padding-left: 160px;
          // color: #c8c8c8;
          // color: #999494;
          border-bottom: 1px dotted #d7d7d7;
        }
      }
    }
  }
}
</style>
<style>
.totalDescription .el-message-box__message {
  padding-left: 0px !important;
}
.FC101 {
  color: #1ab394 !important;

}
.FC104 {

}
.FC108{
  color:#da8f1f !important
}

.FC108 .el-link.el-link--default {
  color:#da8f1f !important
}
.FC104 .el-link.el-link--default {
}
.FC101 .el-link.el-link--default {
  color:#1ab394 !important

}
</style>
